(function(d, t, g, k) {
	var ph = d.createElement(t),
	s = d.getElementsByTagName(t)[0],
	t = (new URLSearchParams(window.location.search)).get(k);
	t && localStorage.setItem(k, t);
	t = localStorage.getItem(k);
	ph.type = 'text/javascript';
	ph.async = true;
	ph.defer = true;
	ph.charset = 'UTF-8';
	ph.src = g + '&v=' + (new Date()).getTime();
	ph.src += t ? '&' + k + '=' + t : '';
	s.parentNode.insertBefore(ph, s);
})(document, 'script', '//huddle.ros.bzh/?p=961&ph_apikey=89e7593242d42620ab1c4edbaf28c25f', 'ph_access_token');

window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('body.collection-avec-volet .multicolumn').forEach(volet => {
    document.querySelectorAll('body.collection-avec-volet div[class*="custom-slideshow-content-block"] a').forEach(toggle => {
      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        volet.classList.toggle('is-open')
      })
    })
  })
  document.querySelectorAll('body.parler-belgique-manolo .multicolumn').forEach(volet => {
    document.querySelectorAll('body.parler-belgique-manolo div[class*="custom-slideshow-content-block"] a').forEach(toggle => {
      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        volet.classList.toggle('is-open')
      })
    })
  })
  document.querySelectorAll('body.parler-belgique-manolo .image-with-text').forEach(volet => {
    document.querySelectorAll('body.parler-belgique-manolo div[class*="custom-slideshow-content-block"] a').forEach(toggle => {
      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        volet.classList.toggle('is-open')
      })
    })
  })
})

window.addEventListener('DOMContentLoaded', () => {
  var xhr = new XMLHttpRequest();
  xhr.open('GET', window.location.href, true);
  xhr.onload = function() {
    if (xhr.status == 404) {
      console.log('Page introuvable');
      document.querySelectorAll('body').forEach(volet => {
        volet.classList.add('page-introuvable')
      })
    };
  }
  xhr.send();
})

window.addEventListener('DOMContentLoaded', () => {
  setTimeout(function () {
    document.querySelectorAll('.reussite-educative #pop-convert-app').forEach(origine => {
      origine.shadowRoot.querySelectorAll('.pc-buttons-trigger-wrapper')[0].style.opacity = '0';
      document.querySelectorAll('.rich-text a.button.button--primary[href="#"]').forEach(copycat => {
        copycat.removeAttribute("href");
        copycat.style.cursor = 'pointer';
        copycat.addEventListener('click', (e) => {
          e.preventDefault();
          origine.shadowRoot.querySelectorAll('.pc-button.clickable-effect')[0].click();
        })
      })
    })
    document.querySelectorAll('.libraires #pop-convert-app').forEach(origine => {
      origine.shadowRoot.querySelectorAll('.pc-buttons-trigger-wrapper')[0].style.opacity = '0';
      document.querySelectorAll('.rich-text a.button.button--primary[href="#"]').forEach(copycat => {
        copycat.removeAttribute("href");
        copycat.style.cursor = 'pointer';
        copycat.addEventListener('click', (e) => {
          e.preventDefault();
          origine.shadowRoot.querySelectorAll('.pc-button.clickable-effect')[0].click();
        })
      })
    })
    document.querySelectorAll('.projets-locaux #pop-convert-app').forEach(origine => {
      origine.shadowRoot.querySelectorAll('.pc-buttons-trigger-wrapper')[0].style.opacity = '0';
      document.querySelectorAll('.rich-text a.button.button--primary[href="#"]').forEach(copycat => {
        copycat.removeAttribute("href");
        copycat.style.cursor = 'pointer';
        copycat.addEventListener('click', (e) => {
          e.preventDefault();
          origine.shadowRoot.querySelectorAll('.pc-button.clickable-effect')[0].click();
        })
      })
    })
  }, 2000);
})